import { useContext } from 'preact/hooks';
import { AnalyticsContext } from './AnalyticsContext';

/** Preact hook to access the widget analytics context */
export function useWidgetAnalytics() {
  return useContext(AnalyticsContext);
}
